import React from "react";
import Card from "../../components/Card/Card";
import {
  Button,
  Form,
  TextInput,
  Row,
  Column,
  PasswordInput,
  ButtonSet,
} from "carbon-components-react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";
import http from "../../http-common";
import { SaveModel24 } from "@carbon/icons-react";
import {
  accountRecoverySchema,
  passwordRules,
} from "../../services/SchemaService";

const RecoverAccountPage = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(accountRecoverySchema.concat(passwordRules)),
    mode: "onBlur",
  });

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      const response = await http.post("/applications/recover-account", data);
      toast.success("Conta recuperada com sucesso");
      navigate("../detalhes-conta", { replace: true, state: response.data });
    } catch (error) {
      toast.error(error.response?.data?.message || "Erro ao recuperar conta");
    }
  };
  return (
    <div className="bx--row">
      <div className="bx--col-sm-12 bx--col-lg-8">
        <Card title="Recuperar conta">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Column sm={12} md={6} lg={6} className="required">
                <TextInput
                  id="identificationDocNumber"
                  labelText="Número do Documento de Identificação"
                  maxLength={20}
                  {...register("identificationDocNumber")}
                />
                <p className="field-error">
                  {errors.identificationDocNumber?.message}
                </p>
              </Column>
              <Column sm={12} md={6} lg={6} className="required">
                <TextInput
                  id="phoneNumber"
                  labelText="Número de Telefone"
                  maxLength={9}
                  {...register("phoneNumber")}
                />
                <p className="field-error">{errors.phoneNumber?.message}</p>
              </Column>
            </Row>
            <Row>
              <Column sm={12} md={6} lg={6} className="required">
                <PasswordInput
                  id="password"
                  labelText="Nova Senha"
                  maxLength={16}
                  {...register("password")}
                />
                <p className="field-error">{errors.password?.message}</p>
              </Column>
              <Column sm={12} md={6} lg={6} className="required">
                <PasswordInput
                  id="passwordConfirm"
                  labelText="Confirmação da Senha"
                  maxLength={16}
                  {...register("passwordConfirm")}
                />
                <p className="field-error">{errors.passwordConfirm?.message}</p>
              </Column>
            </Row>
            <Row className="mt-2">
              <Column sm={12} md={12} lg={12} className="form-buttons">
                <ButtonSet>
                  <Button
                    type="submit"
                    renderIcon={SaveModel24}
                    iconDescription="Save"
                  >
                    Recuperar Conta
                  </Button>
                </ButtonSet>
              </Column>
            </Row>
          </Form>
          <p style={{ color: "#000" }} className="mt-1">
            <Link to={"../"}>Clique aqui para aceder a plataforma</Link>
          </p>
        </Card>
      </div>
    </div>
  );
};

export default RecoverAccountPage;
